import React, { useEffect, useState } from "react";
import ctl from "@netlify/classnames-template-literals";
import { Text } from "components";
import { StaticImage } from "gatsby-plugin-image";
import AndriodApp from "svgs/andriod-app.svg";
import IOSApp from "svgs/ios-app.svg";
import AppTop from "svgs/app-top.svg";
import AppBottom from "svgs/app-bottom.svg";

const WalletAd = () => {
  const [closeAd, setCloseAppAd] = useState(false);

  const onClose = () => {
    setCloseAppAd(false);
    sessionStorage.setItem("hasAd", "false");
    document.body.classList.remove(stopScroll);
  };

  useEffect(() => {
    const session = sessionStorage.getItem("hasAd");

    if (session === "false") {
      setCloseAppAd(false);
    } else {
      const timer = setTimeout(() => {
        setCloseAppAd(true);
        document.body.classList.add(stopScroll);
      }, 4000);
      return () => clearTimeout(timer);
    }
  }, [setCloseAppAd]);

  return (
    <>
      {!closeAd ? (
        ""
      ) : (
        <div className={adWrapper}>
          <div className={adInner}>
            <div className={adText}>
              <Text
                variant="h2"
                value="Unlimited FREE Transfers"
                className="font-bold"
              />
              <Text
                variant="p18"
                value="Enjoy a lifetime of unlimited fast and FREE transfers with your Parkway Wallet."
                className="font-medium"
              />
              <div className={apps}>
                <a
                  href="https://apps.apple.com/app/parkway-wallet/id6451072719"
                  target="_blank"
                  rel="noreferrer noopener"
                >
                  <IOSApp />
                </a>
                <a
                  href="https://play.google.com/store/apps/details?id=com.parkway.yurwallet"
                  target="_blank"
                  rel="noreferrer noopener"
                >
                  <AndriodApp />
                </a>
              </div>
              <StaticImage
                src="../../assets/images/pngs/ad/lady-looking-up.png"
                alt="Lady looking up"
              />
            </div>
            <div className={appScreen}>
              <button onClick={() => onClose()} className={cta}>
                Close X
              </button>
              <AppTop className={appTop} />
              <div className={appTopBal}>
                <StaticImage
                  src="../../assets/images/pngs/ad/topbal.png"
                  alt="snapshot of parkway wallet"
                />
              </div>

              <AppBottom className={appBottom} />

              <div className={appBottomBal}>
                <StaticImage
                  src="../../assets/images/pngs/ad/bottom-rec.png"
                  alt="snapshot of parkway wallet"
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

const adWrapper = ctl(`
   fixed
   top-0
   left-0
   right-0
   bottom-0
   h-full
   w-full
   z-[99999]
   bg-black
   bg-opacity-70
   overflow-auto
`);
const adInner = ctl(`
   max-w-[1012px]
   w-4/5
   mx-auto
   mt-[160px]
   mb-[100px]
   bg-[#F9F1D2]
   bg-[url('../assets/images/pngs/ad/ad-background.png')]
   flex
   max-[848px]:flex-col-reverse
   px-[43px]
   max-[388px]:px-[20px]
   pt-[40px]
   transition-opacity
`);

const adText = ctl(`
  w-[312px]
  max-[848px]:w-full
  max-[848px]:mt-[15px]
  text-center
`);

const apps = ctl(`
  flex
  max-[390px]:flex-col
  max-[390px]:items-center
  justify-center
  gap-[10px]
  mt-[12px]
`);

const appScreen = ctl(`
  relative
  w-full
`);

const appTop = ctl(`
  absolute
  bottom-0
  left-[50px]
  max-[998px]:left-0
  max-[848px]:hidden
`);

const appTopBal = ctl(`
  absolute
  bottom-0
  right-[100px]
  max-[848px]:hidden
`);

const appBottom = ctl(`
  absolute
  top-[-39px]
  right-[60px]
  max-[848px]:hidden
`);

const appBottomBal = ctl(`
  absolute
  top-[-25px]
  right-[78px]
  max-[848px]:hidden
`);

const cta = ctl(`
  absolute
  right-[-15px]
  max-[384px]:right-[-5px]
  max-[848px]:top-[-25px]
  text-[#f00]
  font-bold
`);

const stopScroll = ctl(`
  overflow-hidden
`);

export { WalletAd };
